export default "__VITE_ASSET__DFt7FBB2__";